import React from 'react';
import { Button } from '@mui/material';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { useLocale } from '@koopajs/react';

export const GetAttendanceReportButton: React.FC<{}> = () => {
  const { t } = useLocale();
  return (
    <Button
      href="https://usepanorama.atlassian.net/servicedesk/customer/portal/1/create/15"
      startIcon={<BarChartOutlinedIcon />}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
    >
      {t('Components.GetAttendanceReportButton.label')}
    </Button>
  );
};
